import {
	Component,
	Input,
	Output,
	EventEmitter,
	ChangeDetectorRef,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-button-toggle',
	templateUrl: './button-toggle.component.html',
	styleUrls: ['./button-toggle.component.css'],
	imports: [MatButton, NgClass, MatIcon],
})
export class ButtonToggleComponent {
	@Input() selectedButton: SelectedButton = SelectedButton.left;
	@Input() activeLeftButtonIcon: string = '';
	@Input() inactiveLeftButtonIcon: string = '';
	@Input() activeRightButtonIcon: string = '';
	@Input() inactiveRightButtonIcon: string = '';
	@Output() selectedButtonChange = new EventEmitter<SelectedButton>();

	// Enum to track button selection
	ButtonSelected = SelectedButton;

	get isLeftButtonSelected(): boolean {
		return this.selectedButton === SelectedButton.left;
	}

	get isRightButtonSelected(): boolean {
		return this.selectedButton === SelectedButton.right;
	}

	onSelection(button: SelectedButton): void {
		if (this.selectedButton !== button) {
			this.selectedButton = button;
			this.selectedButtonChange.emit(button);
		}
	}
}

export enum SelectedButton {
	left = 'left',
	right = 'right',
}
